// @flow

import formidableSettings from './reducers';

export { receivedFormidableSettings } from './actions';
export {
  getFormSubmitFailedErrorText,
} from './selectors';
export type { State } from './reducers';

export default formidableSettings;
